/**
 * Returns the minimal refill intent for finish_session_match.
 *
 * The server owns all allocation shape (slotCount from sessions.upcoming_queue_slot_count,
 * excludePlayerIds from the finishing court roster). The client only signals intent.
 *
 * @deprecated Used only in the legacy finishMatchCmd fallback path (REACT_APP_SERVER_MATCHMAKING != true).
 * Remove when the feature flag is hardcoded to true and the EF path (completeSessionScoreCmd) is
 * the only code path.  The EF path uses server-computed fills and ignores refillIntent entirely.
 */
export function computeRefillIntent() {
  return { fillEmptySlots: true };
}
